import type { WidgetDefinition } from "@nexus/widget-sdk";
import { manifest, Component, defaultConfig } from ".";

export const definition: WidgetDefinition = {
  id: "protection-overview-campaigns",
  module: { manifest, Component, defaultConfig },
  catalog: {
    description: "One tenant's top campaigns for one report edition, with drill-down.",
    domain: "reports",
    visual: "Carousel",
    purposes: ["reporting"],
    reportEdition: true,
    audiences: ["analyst", "client"],
  },
  layout: { skeleton: "cards" },
  defaultLayoutClassName: "col-span-12 xl:col-span-6",
};
